export const APP_BUILD_VERSION = import.meta.env.VITE_APP_BUILD_VERSION || 'dev';
